// extracted by mini-css-extract-plugin
module.exports = {"FlashSale":"FlashSale_FlashSale__TA2T8","flashSaleCountdown":"FlashSale_flashSaleCountdown__PxVvy","flashSaleEmail":"FlashSale_flashSaleEmail__k8yr_"};